import moment from 'moment';

export const formatDate = (date: Date | string, format?: string) => {
    if (!date) return '';
    const fmt = format ?? 'DD/MM/YYYY';

    // Se o formato inclui horas, o valor vindo do backend é sempre UTC (com ou sem
    // sufixo 'Z') — interpretamos explicitamente como UTC e convertemos para o
    // fuso do navegador do usuário.
    if (fmt.includes('HH') || fmt.includes('mm') || fmt.includes('ss')) {
        return typeof date === 'string' ? moment.utc(date).local().format(fmt) : moment(date).format(fmt);
    }

    return moment(date).format(fmt);
};

export const formatDateToISO = (dateString: string) => {
    if (!dateString) return '';
    const dateStringArray = dateString.split(' ');
    if (dateStringArray.length === 2) {
        const date = dateStringArray[0].split('/').reverse().join('-');
        const time = dateStringArray[1];
        return date + 'T' + time;
    } else if (dateStringArray.length === 1) {
        const date = dateStringArray[0].split('/').reverse().join('-');
        return date + 'T00:00:00';
    }
    return 'Invalid Date';
};

export const formatDateYYYYMMDD = (date: any) => {
    if (!date) return '';
    const month = date.getMonth() + 1;
    return `${date.getFullYear()}-${month < 10 ? '0' + month : month}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        }`;
};

export const formatDateMMddYYYY = (date: any) => {
    if (!date) return '';
    const month = date.getMonth() + 1;
    return `${month < 10 ? '0' + month : month}/${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        }/${date.getFullYear()}`;
};

export const getLast12Months = (date: any, period = 12) => {
    const dates = [];
    while (period >= 0) {
        let month = date.getMonth();
        const year = date.getFullYear();
        dates.push({ month, year });
        month--;
        date.setMonth(month);
        period--;
    }
    return dates;
};

const monthMap = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];

export const formatMonthYear = (month: any, year: any) => {
    return `${monthMap[month]} - ${year}`;
};


